/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_3_RoleInputs */

const en_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No AI lock-in on free plan`)
};

const de_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein KI-Lock-in im Free-Plan`)
};

const fr_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de dépendance à l'IA sur le forfait gratuit`)
};

const es_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin dependencia de IA en el plan gratuito`)
};

const it_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun vincolo AI nel piano gratuito`)
};

const nl_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen AI-lockin op het gratis plan`)
};

const pl_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez uzależnienia od AI w planie darmowym`)
};

const fi_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tekoälylukkoa ilmaisella tasolla`)
};

const da_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen AI-binding på gratis plan`)
};

const sv_landing_testimonial_3_role = /** @type {(inputs: Landing_Testimonial_3_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen AI-inlåsning på gratisplanen`)
};

/**
* | output |
* | --- |
* | "No AI lock-in on free plan" |
*
* @param {Landing_Testimonial_3_RoleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_3_role = /** @type {((inputs?: Landing_Testimonial_3_RoleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_3_RoleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_3_role(inputs)
	if (locale === "fr") return fr_landing_testimonial_3_role(inputs)
	if (locale === "es") return es_landing_testimonial_3_role(inputs)
	if (locale === "it") return it_landing_testimonial_3_role(inputs)
	if (locale === "nl") return nl_landing_testimonial_3_role(inputs)
	if (locale === "pl") return pl_landing_testimonial_3_role(inputs)
	if (locale === "fi") return fi_landing_testimonial_3_role(inputs)
	if (locale === "da") return da_landing_testimonial_3_role(inputs)
	if (locale === "sv") return sv_landing_testimonial_3_role(inputs)
	return en_landing_testimonial_3_role(inputs)
});